import { supabase } from "@/integrations/supabase/client";

export interface UserLocation {
  isEU: boolean;
  isCalifornia: boolean;
  country: string;
  region: string;
}

export const detectUserRegion = async (): Promise<UserLocation> => {
  try {
    const { data, error } = await supabase.functions.invoke('detect-user-location');
    
    if (error) throw error;

    const euCountries = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 
                         'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 
                         'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB'];
    
    return {
      isEU: euCountries.includes(data.country),
      isCalifornia: data.region === 'California' || data.region === 'CA',
      country: data.country,
      region: data.region,
    };
  } catch (error) {
    console.error('Geolocation detection failed:', error);
    return {
      isEU: false,
      isCalifornia: false,
      country: 'US',
      region: 'Unknown',
    };
  }
};

export const shouldShowCCPANotice = (region: string): boolean => {
  return region === 'California' || region === 'CA';
};

export const shouldShowGDPRNotice = (country: string): boolean => {
  const euCountries = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 
                       'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 
                       'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB'];
  return euCountries.includes(country);
};
